import { useState, useEffect } from "react";
import { TextField } from "@rmwc/textfield";
import { Checkbox } from "@rmwc/checkbox";
import { useSelector, useDispatch } from "react-redux";
import { Select } from "@rmwc/select";
import * as validate from "../../validations";
import AddEditAddressInfo from "./AddEditAddressInfo";
import AnimButton from "../../../Button/AnimButton.js";
import { AddCustomerLeadRecord, commonsActionforLeadCustomer, onTextFiledChangeValue, showMoreErr } from "../../../../action/quote_order/leadcustomer.action.js";

const fieldClass = (error, extra = "floating-label-input") => (error == "" || error == undefined ? extra : `${extra} invalid-input`);
const FormField = ({ label, error, errorId, children }) => (
	<div className="form-group col-md-6 col-sm-12">
		<label className="control-label">{label}</label>
		<div className={fieldClass(error)}>
			{children}
			<span className="error-icon icon-info-ico"></span>
			<div className="errorMessage" id={errorId}>
				{error}
			</div>
		</div>
	</div>
);
const SaveBtn = () => (
	<AnimButton className="btn btn-primary" isAnimation={false} id="leadcustomerok" type="submit">
		SAVE
	</AnimButton>
);
const AddEditBillingInfo = () => {
	const dispatch = useDispatch();
	const { displayerrorMessage, LeadCustomerData, editAddressShow, addAddressShow, showMoreWithErr, searchData, targetRedirectUrl, leadSourceData, showInstallationAddressDetails } = useSelector(
		(state) => state.leadcustomerReducer
	);
	const [moreInfo, setMoreInfo] = useState(false);
	const [sameAsInstall, setSameAsInstall] = useState(false);
	const [addNewBillingAddress, setAddNewBillingAddress] = useState(false);
	const [btnHit, setBtnHit] = useState(false);
	useEffect(() => {
		if (editAddressShow || addAddressShow) {
			setMoreInfo(true);
		}
		return () => {
			setMoreInfo(false);
			setSameAsInstall(false);
			setAddNewBillingAddress(false);
			setBtnHit(false);
		};
	}, []);
	useEffect(() => {
		let checkError = Object.entries(displayerrorMessage);
		checkError?.length > 0 &&
			checkError.map(([key, value]) => {
				if (key != "first_name" && key != "last_name" && value != "" && btnHit == false && moreInfo == false && showMoreWithErr == true) {
					setMoreInfo(true);
				}
			});
	}, [displayerrorMessage, showMoreWithErr]);

	const handleMoreInfo = () => {
		setMoreInfo(!moreInfo);
		setBtnHit(true);
		dispatch(showMoreErr(!moreInfo));
	};
	const checkOk = (e) => {
		e.preventDefault();
		let checkError = Object.entries(displayerrorMessage);
		let error = false;
		checkError?.length > 0 &&
			checkError.map(([key, value]) => {
				if (value != "") {
					error = true;
				}
			});
		if (error == false) {
			dispatch(AddCustomerLeadRecord(e, "detail_page"));
		}
	};
	return (
		<>
			<form
				id="configuration"
				className="mb-0"
				name="configuration"
				onSubmit={(e) => {
					setBtnHit(false);
					dispatch(AddCustomerLeadRecord(e, "create"));
				}}
			>
				<div className="row">
					<FormField label="First Name *" error={displayerrorMessage.first_name} errorId="fnameErrorMessage">
						<TextField
							className="astrick"
							name="first_name"
							value={LeadCustomerData.first_name}
							onChange={(e) => {
								dispatch(onTextFiledChangeValue(e, "first_name", "First Name", "LeadCustomer"));
								validate.alphaCheckValue(e, "first_name");
							}}
							onBlur={(e) => validate.alphaCheckValue(e, "first_name")}
							onKeyUp={(e) => validate.alphaCheckValue(e, "first_name")}
							maxLength={50}
						/>
					</FormField>

					<FormField label="Last Name *" error={displayerrorMessage.last_name} errorId="fnameErrorMessage">
						<TextField
							className="astrick"
							name="last_name"
							value={LeadCustomerData.last_name}
							onChange={(e) => {
								dispatch(onTextFiledChangeValue(e, "last_name", "Last Name", "LeadCustomer", "NoValidate2"));
								validate.alphaCheckValue(e, "last_name");
							}}
							onBlur={(e) => validate.alphaCheckValue(e, "last_name")}
							onKeyUp={(e) => validate.alphaCheckValue(e, "last_name")}
							maxLength={50}
						/>
					</FormField>

					<div className="col-md-12 more-info-btn">
						<span onClick={handleMoreInfo} className="add-links">
							<span className={`${moreInfo ? "icon-minus" : "icon-plus"} mr-2`}></span>
							More Information
						</span>
						{!moreInfo && !addNewBillingAddress && <SaveBtn />}
					</div>

					{moreInfo && (
						<>
							<div className="col-md-12 address-type mb-1">
								<span>Installation Address</span>
							</div>

							<FormField label="Email" error={displayerrorMessage.email} errorId="emailErrorMessage">
								<TextField
									className="astrick"
									name="email"
									value={LeadCustomerData.email}
									onKeyUp={(e) => validate.checkValidEmail(e)}
									onChange={(e) => {
										dispatch(onTextFiledChangeValue(e, "email", "Email", "LeadCustomer", "NoValidate"));
										validate.checkValidEmail(e);
									}}
									onBlur={(e) => validate.checkValidEmail(e)}
									maxLength={50}
								/>
							</FormField>

							<FormField label="Cell No." error={displayerrorMessage.mobile_no} errorId="numberErrorMessage">
								<TextField
									className="astrick"
									name="mobile_no"
									maxLength="15"
									value={LeadCustomerData.mobile_no}
									onKeyUp={(e) => validate.isValidUSPhone(e)}
									onChange={(e) => {
										dispatch(onTextFiledChangeValue(e, "mobile_no", "Number", "LeadCustomer", "NoValidate"));
										validate.isValidUSPhone(e);
									}}
									onBlur={(e) => validate.isValidUSPhone(e)}
								/>
							</FormField>

							<FormField label="Phone No." error={displayerrorMessage.phone_no} errorId="numberErrorMessage">
								<TextField
									className="astrick"
									name="phone_no"
									maxLength="10"
									value={LeadCustomerData.phone_no}
									onKeyUp={(e) => {
										validate.numericCheck(e);
										validate.checkValidMobileNumber(e);
									}}
									onChange={(e) => {
										dispatch(onTextFiledChangeValue(e, "phone_no", "Number", "LeadCustomer", "NoValidate"));
										validate.checkValidMobileNumber(e);
									}}
									onBlur={(e) => validate.checkValidMobileNumber(e)}
								/>
							</FormField>

							<div className={Object.keys(searchData).length <= 0 && targetRedirectUrl.form_action != "edit" && targetRedirectUrl.selected_sub_module != 1 ? "form-group col-md-6 col-sm-12" : "d-none"}>
								<label className="control-label">Lead Source</label>
								<div className={fieldClass(displayerrorMessage.source, "floating-label-input floating-label-inside border-0")}>
									<Select
										name="lead_source"
										value={LeadCustomerData.lead_source}
										onChange={(e) => dispatch(onTextFiledChangeValue(e, "lead_source", "Lead Source", "LeadCustomer", "NoValidate"))}
										options={Object.entries(leadSourceData).map(([key, value]) => {
											LeadCustomerData.lead_source = LeadCustomerData.lead_source == undefined ? key : LeadCustomerData.lead_source;
											return { value: key, label: value };
										})}
									/>
									<span className="error-icon icon-info-ico"></span>
									<div className="errorMessage" id="sourceErrorMessage">
										{displayerrorMessage.source}
									</div>
								</div>
							</div>

							{editAddressShow === false ? (
								<>
									<AddEditAddressInfo from="Installation" />
									<div className="col-md-12 more-info-btn">
										<div className="checkbox">
											<Checkbox
												className="secondary checked-color"
												ripple="RipplePropF"
												checked={showInstallationAddressDetails === true}
												onChange={(e) => {
													setAddNewBillingAddress(false);
													dispatch(commonsActionforLeadCustomer(e, "same_as"));
												}}
											/>
											<span className="address-same ml-1">
												Billing Address same as Installation address
												{!showInstallationAddressDetails && !addNewBillingAddress && (
													<span>
														{" "}
														or{" "}
														<span className="add-links" onClick={() => setAddNewBillingAddress(true)}>
															Add New
														</span>
													</span>
												)}
											</span>
										</div>
										{!addNewBillingAddress && <SaveBtn />}
									</div>
								</>
							) : (
								<>
									<AddEditAddressInfo />
									<div className={LeadCustomerData.first_name?.length > 0 ? "col-md-12 more-info-btn" : "col-md-12 more-info-btn justify-content-end"}>
										{LeadCustomerData.first_name?.length > 0 && (
											<div className="text-left selection-back" onClick={checkOk}>
												<span className="icon-arrow-s2 mr-1"></span>
												<span>Back</span>
											</div>
										)}
										<SaveBtn />
									</div>
								</>
							)}
						</>
					)}
					{editAddressShow === false && addNewBillingAddress && !showInstallationAddressDetails && (
						<>
							<div className="col-md-12 address-type mb-1">
								<span>Add New Billing Address</span>
							</div>
							<AddEditAddressInfo from="Billing" />
							<div className="col-md-12 more-info-btn justify-content-end">
								<SaveBtn />
							</div>
						</>
					)}
				</div>
			</form>
		</>
	);
};

export default AddEditBillingInfo;
